import { toastSuccess } from "@hubrise/react-components"
import * as React from "react"
import { useTranslation } from "react-i18next"

import CatalogActions from "shared/components/CatalogActions"
import { useNavigationContext } from "shared/components/NavigationContext"
import useEditor from "shared/hooks/useEditor"
import { ICatalogSummary } from "shared/hubrise/models"
import { findLastBeforeMatch } from "shared/utils/javascript"
import { catalogPath, DisplayMode } from "shared/utils/paths"

import { ActionIcon, ActionLink } from "./Styles"

interface ActionsProps {
  catalogSummaries: Array<ICatalogSummary>
  displayMode: DisplayMode
}

const Actions = ({ catalogSummaries, displayMode }: ActionsProps): JSX.Element => {
  const { t } = useTranslation()
  const { editor, catalog } = useEditor()
  const catalogSummary = catalogSummaries.find((summary) => summary.id === catalog.hrId)!

  const { getCatalogNavigation } = useNavigationContext()

  // Find the last catalog before the one being deleted. Undefined if there is only one catalog.
  const redirectAfterDelete = (): string | undefined => {
    const catalogId = findLastBeforeMatch(catalogSummaries, (summary) => summary.id === catalog.hrId)?.id
    if (catalogId !== undefined) {
      return getCatalogNavigation(catalogId)?.lastVisitedPath(displayMode) ?? catalogPath(catalogId, displayMode)
    }
  }

  return (
    <CatalogActions
      menuLink={({ onClick }) => (
        <ActionLink onClick={onClick}>
          <ActionIcon />
        </ActionLink>
      )}
      catalogSummary={catalogSummary}
      catalogSummaries={catalogSummaries}
      editor={editor}
      setDuplicationInProgress={(state) => {
        if (state) toastSuccess(t("catalogs.actions.duplicate.in_progress"))
      }}
      redirectAfterDelete={redirectAfterDelete()}
    />
  )
}

export default Actions
